import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'

import storage from '@/utils/storage'

Vue.use(Vuex)

let token = ''
let areaId = ''
let openId = ''

try {
  token = storage.get('token') || ''
  areaId = storage.get('areaId') || ''
  openId = storage.get('openId') || ''
} catch (e) {
  console.error(e)
}
// 测试
if (!token && process.env.NODE_ENV === 'development') {
  token = 'eyJhbGciOiJIUzUxMiJ9.eyJyYW5kb21LZXkiOiJkcnVmamkiLCJzdWIiOiJoNSYmJjczYTc2ZjIwMWNmYzQzZWQ4NjYxZDhjOGM1OTBhMjA0IiwiZXhwIjoxNjI3ODY3MTU5LCJpYXQiOjE2MjcyNjIzNTl9.rIoVKJWdU4y0pcJwReG1dmmfCnZQSRw7Q74wjdEFl4dKuUcL3-8X77MkB32y-nF4ytnEFlL9wB_E4jmjdrvyDA'
}

export default new Vuex.Store({
  state: {
    token,
    current: {},
    managerInfo: {},
    areaId,
    areaList: [],
    openId
  },
  mutations: {
    login(state: any, tokenStr: string) {
      state.token = tokenStr
      storage.set('token', tokenStr)
    },
    setOpenId(state: any, openId: string) {
      state.openId = openId
      storage.set('openId', openId)
    },
    logout(state: any) {
      state.token = null
      state.current = null
      storage.remove('token')
    },
    setCurrent(state: any, current: any) {
      state.current = current
    },
    setManagerInfo(state: any, managerInfo: any) {
      state.managerInfo = managerInfo
    },
    setAreaId(state: any, areaIdStr: string) {
      state.areaId = areaIdStr
      if (areaIdStr) {
        storage.set('areaId', areaIdStr)
      } else {
        storage.remove('areaId')
      }
    },
    setAreaList(state: any, areaList: any[]) {
      state.areaList = areaList
    },
  },
})
